import React from 'react';
import { FaFolder } from 'react-icons/fa';
import css from './FolderDownloadButton.module.css';

interface FolderDownloadButtonProps {
  folderName: string;
  onDownload: () => void;
}

const FolderDownloadButton: React.FC<FolderDownloadButtonProps> = ({ 
  folderName, 
  onDownload 
}) => {
  // Decode the folder name for display
  const decodedFolderName = decodeURIComponent(folderName)
    .replace(/REPLACINGSLASHES/g, '/');
  
  // Truncate the folder name if it's longer than 10 characters
  const displayName = decodedFolderName.length > 10 
    ? `${decodedFolderName.slice(0, 5)}...${decodedFolderName.slice(-5)}`
    : decodedFolderName;
  
  return (
    <button 
      className={css.folderDownloadButton}
      onClick={onDownload}
      title={`Download all files from ${decodedFolderName}`}
    >
      <FaFolder className={css.folderIcon} />
      <span>Download Entire {displayName}</span>
    </button>
  );
};

export default FolderDownloadButton;